export default __webpack_public_path__ + "static/media/Hearts.7ba13b86.svg";